const msqc = 'https://www.missouriquiltco.com'
const utm = 'utm_campaign=qthome&utm_medium=microsite&utm_source=quiltingtut'

export type QuickLinkColor = 'softOrange' | 'persianGreen' | 'vividYellow'

export interface QuickLink {
  location: string
  title: string
  icon: string
  textColor: QuickLinkColor
}

export interface SocialLink {
  location: string
  title: string
  logo: string
}

/** Tailwind needs complete class names in source, so dynamic colours go through this map. */
export const quickLinkTextColor: Record<QuickLinkColor, string> = {
  softOrange: 'text-softOrange',
  persianGreen: 'text-persianGreen',
  vividYellow: 'text-vividYellow',
}

const linksConfig = {
  msqc,
  quickLinks: [
    { location: `${msqc}?${utm}`, title: 'Quilt Shop', icon: '/img/header/msqc.svg', textColor: 'softOrange' },
    { location: `${msqc}/pages/daily-deal?${utm}`, title: 'Daily Deal', icon: '/img/header/daily.svg', textColor: 'persianGreen' },
    { location: `${msqc}/collections/on-sale?${utm}`, title: 'Sales / Trending', icon: '/img/header/sale.svg', textColor: 'vividYellow' },
  ] satisfies QuickLink[],
  sisterSites: [
    { location: msqc, title: 'Quilt Shop' },
    { location: `${msqc}/pages/daily-deal`, title: "Quilter's Daily Deal" },
    { location: 'http://quiltsby.me', title: 'Show & Tell for Quilters' },
    { location: 'http://forum.missouriquiltco.com', title: 'Forum' },
    { location: 'http://blog.missouriquiltco.com', title: 'Blog' },
  ],
  // Entries without a location are not rendered.
  social: [
    { location: '', title: 'Pinterest', logo: '/img/social/pinterest.svg' },
    { location: 'https://www.facebook.com/quiltingtutorials', title: 'Facebook', logo: '/img/social/facebook.svg' },
    { location: 'https://www.instagram.com/quilttutorials/', title: 'Instagram', logo: '/img/social/instagram.svg' },
    { location: '', title: 'Youtube', logo: '/img/social/youtube.svg' },
  ] satisfies SocialLink[],
}

export default linksConfig
